export default __webpack_public_path__ + "static/media/sticker-star.d6814240.png";